export default __webpack_public_path__ + "a350b7074bf06c568a070c67f2a7c33b.svg";